<template>
  <div id="app">
    <top-menu />
    <router-view />
    <my-footer />
  </div>
</template>

<script>
import topMenu from './components/topMenu.vue'
import myFooter from './components/Footer'
export default {
  name: 'App',
  components: { topMenu, myFooter },
  data() {
    return {}
  }
}
</script>

<style>
* {
  scroll-behavior: smooth;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0;
  width: 100%;
  scroll-behavior: smooth;
  position: relative;
  user-select: none;
}
.big_des {
  text-align: center;
  width: 70%;
  margin: 0 auto !important;
  margin-bottom: 5%;
}
body {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue